/*
A 'dumb' over-component that includes tabs for PeopleListContainer and SuppliersContainer

*/

import * as React from 'react';
import { RefreshControl, Platform, Animated, LayoutAnimation, StyleSheet } from 'react-native';
import { Container, Header, Title, Content, Text, Button, Icon, Left, Body, Right, List, ListItem, Spinner, InputGroup, Input, Item, View, Tab, Tabs } from 'native-base';
import PopupMenu from '../../components/popupMenu';
import PeopleListContainer from '../People';
//import SuppliersContainer from './SuppliersContainer';
//import FooterButtons from '../../components/footerButtons';

import AnimatedSearchBar from '../../components/animatedSearchBar';

import PersonForm from '../PersonForm';
import PhoneContactsList from '../../components/phoneContactsList';

class PeopleTabs extends React.Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = {
			searching: false,
			adding: false,
			contacts: false,
			personType: 'customer',
			tab: 0,
		};
	}

	onTabChange(i) {
		this.setState({ tab: i.i, personType: i.i == 0 ? 'customer' : 'supplier' });
	}

	userAddTap(kind) {
		if (kind == undefined) return; //cancel
		if (kind === 0) {
			//new
			this.setState({ adding: true });
		} else {
			this.setState({ contacts: true }); //phone book
		}
	}

	phoneContactsSelect(c) {
		//console.log(c);

		this.setState({ contacts: false });
	}

	render() {
		const { adding, tab, personType, contacts, searching, searchString } = this.state;

		return (
			<Container>
				{adding && (
					<PersonForm
						closure={() => {
							this.setState({ adding: false });
						}}
						personType={personType}
					/>
				)}
				{contacts && (
					<PhoneContactsList
						personType={personType}
						closure={() => {
							this.setState({ contacts: false });
						}}
					/>
				)}
				<AnimatedSearchBar
					isSearchActive={searching}
					onChangeText={(searchString) => this.setState({ searchString })}
					onUserAdd={(e, i) => this.userAddTap(i)}
					onSearchOpen={() => {
						LayoutAnimation.linear();
						this.setState({ searching: true });
					}}
					onSearchClose={searching ? () => this.setState({ searching: false }) : () => this.props.navigation.toggleDrawer()}
				/>
				{searching ? (
					<Tabs>
						<Tab heading="Search Results">
							<PeopleListContainer navigation={this.props.navigation} peopleType={'search'} searchString={searchString} />
						</Tab>
					</Tabs>
				) : (
					<Tabs
						initialPage={0}
						page={tab}
						onScroll={(s) => {
							s % 1 == 0 && this.setState({ tab: s });
						}}
						onChangeTab={(i) => {
							this.onTabChange(i);
						}}>
						<Tab heading="Customers">
							<PeopleListContainer navigation={this.props.navigation} peopleType={'customers'} />
						</Tab>
						<Tab heading="Suppliers">
							<PeopleListContainer navigation={this.props.navigation} peopleType={'suppliers'} />
						</Tab>
					</Tabs>
				)}
			</Container>
		);
	}
}

export default PeopleTabs;

const styles = StyleSheet.create({
	container: {
		backgroundColor: '#FBFAFA',
	},
	row: {
		flex: 1,
		alignItems: 'center',
	},
	text: {
		fontSize: 20,
		marginBottom: 15,
		alignItems: 'center',
	},
	mt: {
		marginTop: 18,
	},
});
